export default __webpack_public_path__ + "static/media/sweet2.5e00bdca.jpg";